import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	Button,
	Upload,
	Checkbox,
	Image,
	Select,
	Space,
	InputNumber,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'categoryList':[],
			//'quantity':1,
		};
	}
	
	componentDidMount()
	{
	}

	//init({quantity,categoryIds})
	init({quantity})
	{
		this.setState({
			'quantity':quantity,
		});
	}
	
	quantityChange(type,index)
	{
		let quantity = this.state.quantity;
		
		if('-' == type)
		{
			if(quantity == 1) return false;
			quantity--;
		}
		else if('+' == type)
		{
			quantity++;
		}
		this.setState({'quantity':quantity});
	}
	
	getResult()
	{
		return this.state.quantity;
	}
	
	render()
	{
		return (
			<div>
				<div className="order-category">
					<dl>
						<dt>数量</dt>
						<dd>
							<Input.Group>
								<Space size={2}>
									<Button onClick={()=>this.quantityChange('-')}>-</Button>
									<Input value={this.state.quantity} style={{'width':'80px','textAlign':'center'}} onChange={event=>{ let val = event.target.value; if(val!=+val) val = 1; this.setState({'quantity':val});}} />
									<Button onClick={()=>this.quantityChange('+')}>+</Button>
								</Space>
							</Input.Group>
						</dd>
					</dl>
				</div>
			</div>
		);
	}
}

